<template>
  <!-- 纸质保单 -->
  <div class="main-container">
    <div class="content">
      <div class="info-box">
        <p class="bold">1.可代申请保司清单：</p>
        <p>海保人寿、富德生命、爱心人寿、大家养老、昆仑健康（重疾险除外）信美相互、弘康人寿。以上仅支持首次申请。</p>
        <p class="bold">2.可代为邮寄保司清单【需客户先自行在保司申请】：</p>
        <p>信泰人寿、复星联合、同方全球、长城保险、太平洋健康、盛世中华、中邮、中意人寿、珠江人寿、恒安标准、君康人寿、国联人寿、复星保德信、海港人寿。</p>
        <p class="bold">3.不支持的保单：</p>
        <p>一年期短险及互联网产品均不支持代申请或者代邮寄。</p>
      </div>
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">投保人姓名</span>
          <Input v-model="searchParams.policyerName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">申请时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            transfer
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <Tabs v-model="status" :animated="false" style @on-click="searchAjax()">
        <TabPane label="待完善" name="2"></TabPane>
        <TabPane label="已登记" name="0"></TabPane>
        <TabPane label="待邮寄" name="3"></TabPane>
        <TabPane label="已邮寄" name="1-3"></TabPane>
        <TabPane label="申请失败" name="1-2"></TabPane>
        <Button slot="extra" type="primary" class="tabs-btn" v-if="$units.pointAction('workOrder_2_2')"  ghost @click="importData()">批量导入</Button>
        <Button type="warning" @click="$refs.formModal.open()" slot="extra" v-if="$units.pointAction('workOrder_2_btn1')" class="tabs-btn">新增</Button>
      </Tabs>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" v-if="tableData.length">
          <template slot-scope="{ row }" slot="userName"> {{ row.orgName }}/{{ row.groupName || '-' }}/{{ row.agentName || '-' }} </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="$refs.detailModal.open(row)">查看</span>
          </template>
        </Table>
        <no-data v-else style="margin-top: 250px"></no-data>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
    </div>

    <!-- 详情 -->
    <detail-modal ref="detailModal"></detail-modal>
    <!-- 新增表单-->
    <form-modal ref="formModal" @reload="searchAjax()"></form-modal> <!-- 导入 -->
    <import-tool ref="importTool" @success="searchAjax()"></import-tool>

  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import { config } from './index.config.js';
import formModal from './components/formModal';
import detailModal from './components/detailModal';
import importTool from '@/components/commons/importTool/index2'
export default {
  mixins: [pageTool, config],
  components: { formModal, detailModal,importTool },
  data() {
    return {
      userInfo: {}, //登录用户信息
      userList: [], //业务员列表
      status: '2',
      searchParams: {
        date: []
      }
    };
  },
  activated() {
    this.getUserList();
    this.getList();
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.initListAjax('/buz/paperPolicy/read/list');
  },
  methods: {
    // 导入
    importData(){
      const dic = JSON.parse(localStorage.dic)['PAPER_POLICY_IMPORT_TEMPLATE']
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params:{},
        uploadParams:{},
        template:key,
        templateName:dic[key],
        uploadUrl:"/buz/paperPolicy/import",
        errorUrl:"/buz/paperPolicy/exportError",
      })
    },

    setReqParams(params) {
      params.apiPermissionCode = 'workOrder_2_0';
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    setListParams(params) {
      this.getColumns();
      params.orderBy = 'id';
      params.asc = false;
      params.status = this.status;
      delete params.applyOrgId;
      if (params.date && params.date.length == 2) {
        params.beginTime = params.date[0];
        params.endTime = params.date[1];
      }
      delete params.date;
      if (params.status.includes('-')) {
        const arr = params.status.split('-');
        params.status = arr[0];
        params.result = arr[1];
      }
    },
    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: {
          orgId: this.userInfo.organId
        }
      }).then(res => {
        this.userList = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
